/**
 * ocean colors by number from the lightest to the darkest
 */
export var ocean01 = '#85b6ff';
export var ocean02 = '#458df8';
export var ocean03 = '#095ddb';
export var ocean04 = '#00388c';
